import { LBCircleSkeleton, LBProgressBarChartSkeleton } from '@linearb/buzz';

export const LOADING_MORE_ITEMS_COUNT = 3;

export const LoadingItem = ({ style }) => {
  return (
    <div className='flex w-full items-center justify-start gap-2' style={style}>
      <LBCircleSkeleton className='size-7' />
      <LBProgressBarChartSkeleton className='h-4 w-1/2' />
    </div>
  );
};

export const Loading = ({ lineCount = 5 }) => {
  return (
    <div className='flex size-full flex-col items-start justify-between px-2 py-1'>
      {Array.from({ length: lineCount }).map((_, index) => {
        return <LoadingItem key={index} />;
      })}
    </div>
  );
};
